import React from "react";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@material-ui/core";

const Review = ({ checkoutLive }) => {
  return checkoutLive ? (
    <>
      <Typography variant="h6" gutterBottom>
        Order Summary
      </Typography>
      <List disablePadding>
        {checkoutLive.line_items.map((product) => (
          <ListItem style={{ padding: "10px 0" }} key={product.name}>
            <ListItemText
              primary={product.name}
              secondary={`Quantity: ${product.quantity}`}
            />
            <Typography variant="body2">
              {product.line_total.formatted_with_symbol}
            </Typography>
          </ListItem>
        ))}
        <ListItem style={{ padding: "10px 0" }} key="">
          <ListItemText primary="Shipping" />
          <Typography variant="body2">
            {checkoutLive.shipping.price.formatted_with_symbol}
          </Typography>
        </ListItem>
      </List>
      <ListItem style={{ padding: "10px 1" }}>
        <ListItemText primary="Total" />
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
          {checkoutLive.total.formatted_with_symbol}
        </Typography>
      </ListItem>
    </>
  ) : (
    <div>
      <CircularProgress />
    </div>
  );
};

export default Review;
